import { useState } from '#imports';

export const EditModes = {
  GROUP: 'group',
  TEMPLATE: 'template',
};

export const useEditMode = () => useState<string>('editMode', () => EditModes.TEMPLATE);
export const useCurrentTrackerID = () => useState<string>('currentTrackerID', () => '');
